import React from 'react';
import styles from './notes.module.sass';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { deleteIOCNote } from '../../../../redux/actions/ioc';

export function NoteDetails({ description, isMine, iocUUID, noteUUID }) {
  const dispatch = useDispatch();
  const iocNoteDeleting = useSelector((state) => state.ioc.iocNoteDeleting);
  const deleteNote = () => {
    dispatch(deleteIOCNote(iocUUID, noteUUID));
  };

  return (
    <div style={{ width: 344 }}>
      <p className={styles['note-description']}>{description}</p>
      {isMine && (
        <div className={styles['note-delete-section']}>
          <Button
            style={{
              color: '#E84749',
              fontSize: 14,
              fontWeight: 400,
            }}
            loading={iocNoteDeleting}
            onClick={() => deleteNote()}
            className={styles['note-delete-button']}
            type="link"
          >
            Delete Note
          </Button>
        </div>
      )}
    </div>
  );
}
